import { modulesService } from 'src/services'

export function loadModules({ dispatch, commit, state }) {
  commit('startLoading');
  modulesService.getModules(function(data) {
    if(data.status === 401) dispatch('authentication/expired', data, {root:true});
    else commit('receivedData', data['hydra:member'])
  })
}
